import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jr/FrontEnd/app/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/jr/FrontEnd/app/globals.css");
